import tinyapp from "./projects/0_tinyapp";
import tweeter from "./projects/1_tweeter";
import scheduler from "./projects/2_scheduler";
import fpo from "./projects/3_fpo";
import yourTube from "./projects/4_your-tube";
import jungle from "./projects/5_jungle";

const portfolio = {
  0: tinyapp,
  1: tweeter,
  2: scheduler,
  3: fpo,
  4: yourTube,
  5: jungle
};

export default portfolio;
